
@defer (when isLoginModalOpened) {
@if (!isLoggedIn) {
  <sd-modal-default
    [modalTitle]="'account.dropdown.login.label' | translate"
    [modalTitleLevel]="4"
    [(isOpened)]="isLoginModalOpened"
    (isOpenedChange)="onLoginModalClose($event)"
    [noPadding]="true"
    >
    @if (!!loginUrl) {
      <iframe
        title="Ouverture de la pop-in de connection"
        wcIframeResizer
        [src]="loginUrl"
        width="100%"
        style="border: none; min-height: 500px"
      ></iframe>
    }
  </sd-modal-default>
}
}
